/* eslint-disable import/prefer-default-export */
import { BIControlPanel } from '../interfaces/BIControlPanel';

export const enUS: BIControlPanel = {
  title: 'BI Control Panel',
  tabs: {
    biParamaters: 'BI Parameters',
    biApproval: 'BI Approval',
  },
  filters: {
    placeholder: 'Select',
    noData: 'No results found',
    endText: 'All items have been loaded',
    expandedTooltip: 'Hide search options',
    collapsedTooltip: 'Expand search options',
    panelExpanded: 'Panel open',
    panelCollapsed: 'Panel closed',
    financialGroupRequired: 'Financial group*',
    financialGroup: 'Financial group',
    contract: 'Contract',
    subcontract: 'Subcontract',
    carrier: 'Carrier',
    competency: 'Competency',
  },
  table: {
    rowsPerPage: 'Rows per page',
    of: 'of',
    invoiceValue: 'Invoice value',
    invoicePageTotal: 'Page total',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    lastUpdateDate: 'Last update date',
    updateUser: 'Update user',
  },
  messages: {
    parametersPanelLoadError: 'An error occurred while loading the parameters panel.',
    approvalPanelLoadError: 'An error occurred while loading the approval panel.',
    additionalFiltersLoadError: 'An error occurred while loading the additional filters.',
    filterOptionsLoadError: 'An error occurred while fetching the filter options.',
    filtersClearError: 'An error occurred while clearing the filters.',
    dataSearchError: 'An error occurred while searching the data.',
    tableDataSearchError: 'An error occurred while fetching the BI table data.',
    statusUpdateError: 'An error occurred while updating the status.',
    pageChangeError: 'An error occurred while changing the page.',
    pageSizeChangeError: 'An error occurred while changing the row count.',
  },
};
